import { Eye, Gauge, LockKeyhole, UnlockKeyhole, Users } from "lucide-react";
import type { OverviewResponse } from "../api/client";

const formatter = new Intl.NumberFormat("zh-HK");

export function KpiGrid({ totals }: { totals: OverviewResponse["totals"] }) {
  const items = [
    { label: "總觀看", value: totals.views, icon: Eye },
    { label: "不重複訪客", value: totals.unique_visitors, icon: Users },
    { label: "會員文章觀看", value: totals.member_views, icon: LockKeyhole },
    { label: "一般文章觀看", value: totals.public_views, icon: UnlockKeyhole },
    { label: "平均停留", value: `${formatter.format(totals.avg_duration_ms)} ms`, icon: Gauge }
  ];
  return (
    <section className="kpi-grid">
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <article className="kpi-card" key={item.label}>
            <div>
              <span>{item.label}</span>
              <strong>{typeof item.value === "number" ? formatter.format(item.value) : item.value}</strong>
            </div>
            <Icon size={20} aria-hidden="true" />
          </article>
        );
      })}
    </section>
  );
}
